import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("wf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("wf_token");
      localStorage.removeItem("wf_user");
      // Only redirect if we're inside an authenticated section
      if (
        typeof window !== "undefined" &&
        !["/login", "/", ""].includes(window.location.pathname) &&
        !window.location.pathname.startsWith("/r/")
      ) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default client;
